/*
  iCoins Collection Real Madrid — lógica de la distributiva (sección icoins-rm).
  Misma base que la del Barça (icoins-pdp.js) más el giro de la moneda en la ficha.
  Agrega al carrito con la Ajax API de Shopify y abre el carrito lateral de Dawn
  (Configuración del tema → Carrito → Tipo: Panel). Si el tema usa otro tipo de
  carrito, muestra un aviso con link al carrito.
*/
(() => {
  const SOBRES_POR_CAJA = 5;
  const TIERS = {
    core: { label: 'Core', finish: 'Plateado', rarity: 'Regular' },
    star: { label: 'Star', finish: 'Oro holográfico', rarity: '1 de cada 5' },
    gold: { label: 'Gold 24K', finish: 'Baño de oro 24K', rarity: '1 de cada 80' },
  };

  function init(root) {
    if (!root || root.dataset.icrmReady) return;
    root.dataset.icrmReady = 'true';

    const $ = sel => root.querySelector(sel);
    const $$ = sel => [...root.querySelectorAll(sel)];
    const d = root.dataset;
    const fmt = new Intl.NumberFormat(d.locale || 'es', { style: 'currency', currency: d.currency || 'EUR' });
    const money = cents => fmt.format(Math.round(cents) / 100);
    const bump = el => { if (!el) return; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); };
    const cajasTxt = n => (n === 1 ? '1 caja' : `${n} cajas`);

    const PRICE = { album: +d.albumPrice || 0, caja: +d.cajaPrice || 0 };
    const VARIANT = { album: d.albumVariant, caja: d.cajaVariant };
    const ENVIO = +d.envio || 0;

    /* ---------- Galería ---------- */
    const main = $('[data-main-image]');
    $$('.thumb').forEach(t => t.addEventListener('click', () => {
      $$('.thumb').forEach(o => o.setAttribute('aria-pressed', o === t));
      main.style.opacity = 0;
      setTimeout(() => {
        main.src = t.dataset.src;
        main.alt = t.dataset.alt;
        main.classList.toggle('is-coin', t.hasAttribute('data-coin'));
        main.style.opacity = 1;
      }, 150);
    }));

    /* ---------- Cantidades ---------- */
    const getQty = q => +q.querySelector('output').textContent;
    const setQty = (q, v) => {
      const min = +(q.dataset.min || 1), max = +(q.dataset.max || 10);
      const val = Math.max(min, Math.min(max, v));
      const out = q.querySelector('output');
      out.value = out.textContent = val;
      q.querySelector('[data-dec]').disabled = val <= min;
      q.querySelector('[data-inc]').disabled = val >= max;
      q.dispatchEvent(new Event('change', { bubbles: true }));
    };
    $$('[data-qty]').forEach(q => {
      q.querySelector('[data-dec]').addEventListener('click', () => setQty(q, getQty(q) - 1));
      q.querySelector('[data-inc]').addEventListener('click', () => setQty(q, getQty(q) + 1));
    });

    /* ---------- Combo: N álbumes + N cajas ---------- */
    const comboQty = $('[data-combo-qty]');
    const comboAlbumQty = $('[data-combo-album-qty]');
    const albumTxt = n => (n === 1 ? '1 álbum' : `${n} álbumes`);
    const chips = $$('.chip');
    const comboTotal = n => PRICE.album + n * PRICE.caja;

    // Etiqueta de los botones rápidos: "Envío gratis" en la primera cantidad que llega al mínimo; si no, "Popular" en 2
    const freeChip = ENVIO ? chips.find(c => comboTotal(+c.dataset.cajas) >= ENVIO) : null;
    chips.forEach(c => {
      if (freeChip) { if (c === freeChip) c.dataset.badge = 'Envío gratis'; }
      else if (c.dataset.cajas === '2') c.dataset.badge = 'Popular';
    });

    const updateCombo = () => {
      const n = getQty(comboQty);
      const a = getQty(comboAlbumQty);
      const total = a * PRICE.album + n * PRICE.caja;
      $('[data-combo-count]').textContent = `\u00d7${n}`;
      $('[data-combo-album-count]').textContent = `\u00d7${a}`;
      $('[data-sum-album-label]').textContent = a === 1 ? '1 Álbum Premium' : `${a} Álbumes Premium`;
      $('[data-sum-album]').textContent = money(a * PRICE.album);
      $('[data-sum-cajas-label]').textContent = `${cajasTxt(n)} (${n * SOBRES_POR_CAJA} sobres)`;
      $('[data-sum-cajas]').textContent = money(n * PRICE.caja);
      $('[data-combo-total]').textContent = money(total);
      const ctaPrice = $('[data-cta-price]');
      if (ctaPrice) ctaPrice.textContent = `— ${money(total)}`;
      $('[data-sticky-name]').textContent = `Combo: ${albumTxt(a)} + ${cajasTxt(n)}`;
      $('[data-sticky-price]').textContent = money(total);
      // 1 de cada 5 monedas es especial → de media, 1 Star por caja
      $('[data-combo-hint]').innerHTML =
        `${n * SOBRES_POR_CAJA} monedas para tu álbum. De media te ${n === 1 ? 'saldrá' : 'saldrán'} <b>${n} ${n === 1 ? 'moneda Star' : 'monedas Star'}</b>.`;

      const ship = $('[data-combo-ship]');
      if (ENVIO) {
        ship.hidden = false;
        const falta = ENVIO - total;
        ship.classList.toggle('is-pending', falta > 0);
        ship.innerHTML = falta > 0
          ? `Te faltan <b>${money(falta)}</b> para el envío gratis.`
          : '✓ Este combo tiene envío gratis.';
      }
      chips.forEach(c => c.setAttribute('aria-pressed', +c.dataset.cajas === n));
      bump($('[data-combo-total]'));
      bump($('[data-combo-count]'));
      bump($('[data-combo-album-count]'));
    };
    comboQty.addEventListener('change', updateCombo);
    comboAlbumQty.addEventListener('change', updateCombo);
    chips.forEach(c => c.addEventListener('click', () => setQty(comboQty, +c.dataset.cajas)));

    /* ---------- Productos por separado ---------- */
    $$('[data-product]').forEach(box => {
      const q = box.querySelector('[data-qty]');
      const card = box.closest('.product');
      const btn = box.querySelector('[data-add]');
      const isAlbum = box.dataset.product === 'album';
      const detailDefault = card.querySelector('[data-detail]').textContent;
      q.addEventListener('change', () => {
        const n = getQty(q);
        card.querySelector('[data-total]').textContent = money(n * (isAlbum ? PRICE.album : PRICE.caja));
        if (isAlbum) {
          card.querySelector('[data-detail]').textContent = n === 1 ? detailDefault : `${n} álbumes \u00d7 ${money(PRICE.album)}`;
        } else {
          card.querySelector('[data-detail]').textContent = `${cajasTxt(n)} · ${n * SOBRES_POR_CAJA} sobres`;
          if (!btn.disabled) btn.textContent = n === 1 ? 'Comprar caja' : `Comprar ${n} cajas`;
        }
        bump(card.querySelector('[data-total]'));
      });
    });
    $$('[data-qty]').forEach(q => setQty(q, getQty(q)));

    /* ---------- Aviso (toast) ---------- */
    const toast = $('[data-toast]');
    let toastTimer;
    const showToast = (html, isError = false) => {
      toast.innerHTML = html;
      toast.classList.toggle('is-error', isError);
      toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove('is-visible'), isError ? 5000 : 3500);
    };

    /* ---------- Agregar al carrito ---------- */
    const itemsFor = btn => {
      const kind = btn.dataset.add;
      if (kind === 'combo') {
        const n = getQty(comboQty), a = getQty(comboAlbumQty);
        return { items: [{ id: +VARIANT.album, quantity: a }, { id: +VARIANT.caja, quantity: n }],
                 label: `Combo ${albumTxt(a)} + ${cajasTxt(n)}` };
      }
      const n = getQty(btn.closest('[data-product]').querySelector('[data-qty]'));
      return kind === 'album'
        ? { items: [{ id: +VARIANT.album, quantity: n }], label: n === 1 ? 'Álbum' : `${n} álbumes` }
        : { items: [{ id: +VARIANT.caja, quantity: n }], label: n === 1 ? '1 caja de sobres' : `${n} cajas de sobres` };
    };

    const addToCart = async btn => {
      const { items, label } = itemsFor(btn);
      if (items.some(i => !i.id)) {
        showToast('Falta configurar el producto en el editor del tema.', true);
        return;
      }
      const drawer = document.querySelector('cart-drawer');
      const notification = document.querySelector('cart-notification');
      const sectionsHost = drawer || notification;
      const sections = sectionsHost && typeof sectionsHost.getSectionsToRender === 'function'
        ? sectionsHost.getSectionsToRender().map(s => s.id)
        : ['cart-icon-bubble'];

      btn.classList.add('is-loading');
      btn.disabled = true;
      try {
        const root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(`${root_url}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: sections.join(','), sections_url: window.location.pathname }),
        });
        const data = await res.json();
        if (!res.ok || data.status) {
          showToast(data.description || data.message || 'No se pudo agregar al carrito.', true);
          return;
        }

        // Avisar a Dawn (contador del carrito, recomendaciones, etc.)
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'icoins-rm', cartData: data });
        }

        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          // Sin carrito lateral: actualizar el ícono y mostrar link al carrito
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && data.sections && data.sections['cart-icon-bubble']) {
            const html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            const inner = html.querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }
          showToast(`✓ ${label} añadido al carrito <a href="${d.cartUrl || '/cart'}">Ver carrito</a>`);
        }
      } catch (err) {
        showToast('No se pudo agregar al carrito. Probá de nuevo.', true);
      } finally {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }
    };
    $$('[data-add]').forEach(btn => btn.addEventListener('click', () => addToCart(btn)));

    /* ---------- Leer más ---------- */
    $$('[data-more]').forEach(b => b.addEventListener('click', () => {
      const p = b.previousElementSibling;
      const open = p.classList.toggle('is-open');
      b.textContent = open ? 'Leer menos' : 'Leer más';
      b.setAttribute('aria-expanded', open);
    }));

    /* ---------- Colección: mostrar/ocultar y links de Tres niveles ---------- */
    const toggle = $('[data-grid-toggle]');
    const wrap = $('[data-grid-wrap]');
    const setOpen = open => {
      wrap.classList.toggle('is-collapsed', !open);
      toggle.setAttribute('aria-expanded', open);
      toggle.querySelector('[data-label]').textContent = open ? 'Ocultar la colección' : 'Ver la colección';
    };
    toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));

    $$('[data-goto]').forEach(a => a.addEventListener('click', e => {
      e.preventDefault();
      setOpen(true);
      const key = a.dataset.goto;
      const target = key === 'coleccion' ? $('.coleccion') : $(`[data-anchor="${key}"]`);
      if (!target) return;
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth', block: key === 'coleccion' ? 'start' : 'center' });
        const coin = target.querySelector('.coin');
        if (coin) { coin.classList.remove('is-highlight'); void coin.offsetWidth; coin.classList.add('is-highlight'); }
      }, 50);
    }));

    /* ---------- Ficha de moneda ---------- */
    const modal = $('[data-modal]');
    const coinBtns = $$('[data-coins] .coin');
    let current = 0;
    const render = i => {
      const b = coinBtns[i].dataset, t = TIERS[b.tier];
      current = i;
      $('[data-pm]').className = `pm pm--${b.tier}`;
      $('[data-pm-num]').textContent = b.tier !== 'core' ? b.num : `#${b.num}`;
      const img = $('[data-pm-img]');
      img.src = b.img;
      img.alt = b.tier === 'core' ? `Moneda Core de ${b.name}` : `Moneda ${t.label}`;
      $('[data-pm-tier]').textContent = t.label;
      $('[data-pm-name]').textContent = b.name;
      $('[data-pm-role]').textContent = b.role;
      $('[data-pm-finish]').textContent = t.finish;
      $('[data-pm-rarity]').textContent = t.rarity;
      $('[data-pm-extra]').innerHTML = b.extra;
      // Al abrir: la moneda Core gira, muestra el reverso y vuelve a la cara
      const coin = $('[data-pm-coin]');
      coin.classList.remove('is-flipped', 'is-intro'); void coin.offsetHeight;
      if (b.tier === 'core') coin.classList.add('is-intro');
      coin.disabled = b.tier !== 'core';
      $('[data-pm-hint]').hidden = b.tier !== 'core';
    };
    // Tocar la moneda de la ficha la da vuelta
    $('[data-pm-coin]').addEventListener('click', () => {
      const coin = $('[data-pm-coin]');
      coin.classList.remove('is-intro');
      coin.classList.toggle('is-flipped');
    });
    const closeModal = () => {
      if (!modal.open) return;
      modal.classList.add('is-closing');
      setTimeout(() => { modal.classList.remove('is-closing'); modal.close(); }, 190);
    };
    coinBtns.forEach((b, i) => b.addEventListener('click', () => { render(i); modal.showModal(); }));
    modal.addEventListener('click', e => {
      if (e.target === modal || e.target.closest('[data-close]')) closeModal();
      const step = e.target.closest('[data-step]');
      if (step) render((current + +step.dataset.step + coinBtns.length) % coinBtns.length);
    });
    modal.addEventListener('cancel', e => { e.preventDefault(); closeModal(); });
    modal.addEventListener('close', () => coinBtns[current] && coinBtns[current].focus());
    modal.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') modal.querySelector('[data-step="1"]').click();
      if (e.key === 'ArrowLeft') modal.querySelector('[data-step="-1"]').click();
    });

    /* ---------- Acordeón ---------- */
    const accBtns = $$('.acc__btn');
    accBtns.forEach(btn => btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') !== 'true';
      accBtns.forEach(o => {
        o.setAttribute('aria-expanded', 'false');
        o.querySelector('.acc__icon').textContent = '+';
        root.querySelector(`#${o.getAttribute('aria-controls')}`).classList.remove('is-open');
      });
      if (open) {
        btn.setAttribute('aria-expanded', 'true');
        btn.querySelector('.acc__icon').textContent = '\u2013';
        root.querySelector(`#${btn.getAttribute('aria-controls')}`).classList.add('is-open');
      }
    }));

    /* ---------- Barra fija mobile ---------- */
    // Aparece cuando el botón del combo sale de pantalla y se oculta mientras se ven las tarjetas de compra
    const sticky = $('[data-sticky]');
    let heroOut = false, productsIn = false;
    const updateSticky = () => {
      const show = heroOut && !productsIn;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', !show);
      sticky.querySelector('button').tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(([e]) => { heroOut = !e.isIntersecting && e.boundingClientRect.top < 0; updateSticky(); })
      .observe($('[data-hero-buy]'));
    new IntersectionObserver(([e]) => { productsIn = e.isIntersecting; updateSticky(); }).observe($('.products'));

    /* ==========================================================
       ANIMACIONES E INTERACCIONES (v2)
       ========================================================== */
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hasIO = 'IntersectionObserver' in window;
    const inEditor = window.Shopify && Shopify.designMode;

    // Aparición al hacer scroll (escalonada dentro de cada grupo). En el editor de temas no se usa.
    if (hasIO && !reduceMotion && !inEditor) {
      const GROUPS = [
        '.completa__head', '.product', '.niveles__head > *', '.level',
        '.panel__title, .panel__sub, .panel__controls', '.card-white, .card-blue', '.acc__item',
        '.cule__text > *', '.cule__media img', '.joy h2, .joy__sub', '.post',
      ];
      const items = [];
      GROUPS.forEach(sel => $$(sel).forEach((el, i) => {
        el.classList.add('reveal');
        el.style.setProperty('--d', Math.min(i, 5) * 110 + 'ms');
        items.push(el);
      }));
      const io = new IntersectionObserver(entries => entries.forEach(e => {
        const el = e.target;
        // Si se pasó de largo (scroll rápido o salto con ancla) se muestra sin esperar
        if (!e.isIntersecting && e.boundingClientRect.top < 0) { el.classList.remove('reveal'); io.unobserve(el); return; }
        if (!e.isIntersecting) return;
        el.classList.add('is-visible');
        io.unobserve(el);
        setTimeout(() => el.classList.remove('reveal', 'is-visible'), 900 + parseInt(el.style.getPropertyValue('--d'), 10));
      }), { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      items.forEach(el => io.observe(el));
    }

    // Pantallas táctiles: la tarjeta centrada en pantalla se activa sola
    if (hasIO && window.matchMedia('(hover: none) and (max-width: 1023px)').matches) {
      const io = new IntersectionObserver(entries => entries.forEach(e => e.target.classList.toggle('is-active', e.isIntersecting)),
        { rootMargin: '-45% 0px -45% 0px' });
      $$('.level, .product').forEach(el => io.observe(el));
    }

    // Clic en una tarjeta de "Tres niveles": queda seleccionada hasta tocar otra (o la misma)
    const levels = $$('.level');
    levels.forEach(card => card.addEventListener('click', e => {
      if (e.target.closest('a')) return;
      const on = !card.classList.contains('is-selected');
      levels.forEach(c => c.classList.remove('is-selected'));
      card.classList.toggle('is-selected', on);
    }));

    // Contador animado en las etiquetas del hero ("34", "+8")
    if (hasIO && !reduceMotion) {
      const io = new IntersectionObserver(entries => entries.forEach(e => {
        if (!e.isIntersecting) return;
        const el = e.target, target = Number(el.dataset.count), prefix = el.dataset.prefix || '';
        const start = performance.now();
        const tick = now => {
          const p = Math.min((now - start) / 1400, 1);
          el.textContent = prefix + Math.round(target * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        io.unobserve(el);
      }), { threshold: 0.6 });
      $$('.badge b, .badge strong').forEach(el => {
        const m = el.textContent.trim().match(/^(\+?)(\d+)$/);
        if (!m) return;
        el.dataset.prefix = m[1];
        el.dataset.count = m[2];
        el.textContent = m[1] + '0';
        io.observe(el);
      });
    }

    // Onda (ripple) al tocar un botón
    $$('.btn-gold, .toggle').forEach(btn => btn.addEventListener('pointerdown', e => {
      if (reduceMotion || btn.disabled) return;
      const rect = btn.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const dot = document.createElement('span');
      dot.className = 'ripple';
      dot.style.width = dot.style.height = size + 'px';
      dot.style.left = (e.clientX - rect.left - size / 2) + 'px';
      dot.style.top = (e.clientY - rect.top - size / 2) + 'px';
      btn.appendChild(dot);
      dot.addEventListener('animationend', () => dot.remove());
    }));
  }

  const initAll = () => document.querySelectorAll('[data-icrm]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Editor de temas: volver a inicializar cuando se edita la sección
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-icrm]')));
})();
